import { IFramework, IWebServiceManager, HttpMethod } from '@truckdown/framework';
import { IActivityManager } from "./IActivityManager";
import { GetThrottleCountsRequest } from "./Models/GetThrottleCountsRequest";
import { ThrottleCounts } from "./Models/ThrottleCounts";

export class ActivityManager implements IActivityManager {
    constructor(framework: IFramework) {
        this.manager = framework.getRequiredService<IWebServiceManager>('IWebServiceManager');
    }

    readonly manager: IWebServiceManager;
    private readonly errorMsg: string = 'Error in activity manager request';
    private readonly basePath: string = '/tools/throttling/activities';

    GetCounts(request: GetThrottleCountsRequest): Promise<ThrottleCounts> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath,
            method: HttpMethod.POST
        }, request);

        return this.manager
            .get<any>(req)
            .then((res) => {
                return new ThrottleCounts(res);
            });
    }

    async Add(prefix: string, key: string) {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath + '/' + encodeURIComponent(prefix) + '/' + encodeURIComponent(key),
            method: HttpMethod.PUT
        });
        
        var res = await this.manager.send(req);
        if (!res.ok) {
            console.log(this.errorMsg, req, res);
            throw new Error(this.errorMsg);
        }
    }

    async Clear(key: string) {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath + '/' + encodeURIComponent(key),
            method: HttpMethod.PUT
        });

        var res = await this.manager.send(req);
        if (!res.ok) {
            console.log(this.errorMsg, req, res);
            throw new Error(this.errorMsg);
        }
    }

    async Delete(key: string) {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath + '/' + encodeURIComponent(key),
            method: HttpMethod.DELETE
        });

        var res = await this.manager.send(req);
        if (!res.ok) {
            console.log(this.errorMsg, req, res);
            throw new Error(this.errorMsg);
        }
    }
}